<template>
    <div>
        <p-header title="支付設定" :left-btn="isEdit ? '儲存' : '編輯'" @onLeftBtn="isEdit = !isEdit"/>
        <div class="tip" v-if="tip">{{ tip }}</div>
        <div class="empty" v-if="! agreements.length">
            <img src="@/assets/img/empty-card.png">
            <div class="title">
                尚未新增信用卡
            </div>
        </div>
        <div class="list" v-else>
            <div class="item">
                <div class="content">
                    <div class="img">
                        <img src="@/assets/img/credit/cash.png">
                    </div>
                    <div class="title">
                        現金付款
                    </div>
                </div>
                <div class="buttons">
                    <span v-if="isCashPay">預設</span>
                    <div class="default" v-else @click="setDefaultCash">
                        設為預設
                    </div>
                </div>
            </div>
            <div class="item" v-for="agreement in agreements" :key="agreement.id">
                <div class="content">
                    <div class="img">
                        <img v-if="agreement.type === 'jcb'" src="@/assets/img/credit/jcb.png">
                        <img v-else-if="agreement.type === 'visa'" src="@/assets/img/credit/visa.png">
                        <img v-else-if="agreement.type === 'master'" src="@/assets/img/credit/mastercard.png">
                        <img v-else src="@/assets/img/credit/card.png">
                    </div>
                    <div class="title">
                        **** {{ agreement.card_suffix }}
                    </div>
                </div>
                <div class="buttons" v-show="!isEdit">
                    <span v-if="agreement.is_default">預設</span>
                    <div class="default" v-else @click="setDefaultAgreement(agreement.id)">
                        設為預設
                    </div>
                </div>
                <div class="buttons" v-show="isEdit">
                    <img src="@/assets/img/trash.png" @click="onDelete(agreement.id)">
                </div>
            </div>
        </div>
        <set-mail-modal ref="setMailModal" title="請先填寫電子信箱以便收取電子發票" @onConfirm="onConfirm"/>
    </div>
</template>

<script>
    import Header from './components/Header';
    import { mapActions, mapGetters } from 'vuex';
    import Swal from 'sweetalert2';
    import SetMailModal from './components/modal/SetMailModal';

    export default {
        name: 'Agreements',
        components: {
            'p-header': Header,
            'set-mail-modal': SetMailModal,
        },
        data() {
            return {
                isEdit: false,
                tip: null,
            }
        },
        computed: {
            isCashPay() {
                return this.agreements.findIndex(agreement => agreement.is_default) < 0;
            },
            ...mapGetters(['agreements', 'user'])
        },
        methods: {
            onConfirm() {
                this.tip = '信箱設定完成，請再次點擊新增信用卡';
            },
            onDelete(id) {
                this.deleteAgreement(id).catch(err => {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                })
            },
            ...mapActions(['setDefaultAgreement', 'deleteAgreement', 'setDefaultCash'])
        },
    };
</script>

<style lang="scss" scoped>
    .tip {
        color: #4A90E2;
    }

    .list {
        margin: 15px;

        .button {
            border: 1px solid #E6E8ED;
            border-radius: 5px;
            padding: 5px 10px;
            color: #4A4A4A;
            font-size: 14px;
            line-height: 26px;
            text-align: left;
            margin-bottom: 25px;
            display: flex;
            align-items: center;

            span {
                font-size: 25px;
                margin-right: 5px;
            }
        }

        .item {
            border: 1px solid #E6E8ED;
            border-radius: 5px;
            padding: 5px 10px;
            display: flex;
            margin: 10px 0;
            justify-content: space-between;
            align-items: center;

            .img {
                height: 36px;
                width: 36px;
                margin-right: 10px;
            }

            .content {
                display: flex;
                align-items: center;
            }
        }
    }

    .buttons {
        .default {
            color: #787878;
            font-size: 12px;
            line-height: 25px;
        }

        span {
            color: #339933;
        }

        img {
            height: 24px;
            width: 24px;
        }
    }

    .empty {
        margin-top: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            height: 50px;
            width: 50px;
        }

        .title {
            margin-top: 30px;
            color: #4A4A4A;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
        }

        .button {
            margin-top: 34px;
            height: 25px;
            border-radius: 13px;
            background-color: #339933;
            color: #FFFFFF;
            font-size: 12px;
            line-height: 17px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100px;
        }
    }
</style>
